import { Controller } from "@hotwired/stimulus"

// Handles the "Deelnemende leden" section in the planning wizard confirm step.
// Checkboxes are "exclude" toggles: checked = excluded from planning.
export default class extends Controller {
  static targets = ["counter", "checkbox"]
  static values = {
    selectedLabel: { type: String, default: "geselecteerd" }
  }

  connect() {
    this.updateCount()
  }

  toggle(event) {
    const label = event.target.closest("label")
    if (label) {
      const nameSpan = label.querySelector("[data-member-select-target='name']")
      if (nameSpan) {
        nameSpan.classList.toggle("text-gray-400", event.target.checked)
        nameSpan.classList.toggle("line-through", event.target.checked)
        nameSpan.classList.toggle("text-gray-700", !event.target.checked)
      }
    }
    this.updateCount()
  }

  updateCount() {
    const total = this.checkboxTargets.length
    const excluded = this.checkboxTargets.filter(cb => cb.checked).length
    this.counterTarget.textContent = `(${total - excluded}/${total} ${this.selectedLabelValue})`
  }
}
